import React, { useState } from "react";
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AddDepartmentSer } from "./Services/AddDepartmentSer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";


import axios from "axios";
const Departments = () => {

  const [ids, setIds] = useState(null);

  const [departments, setDepartments] = useState([]);
  const [selectedDepartmentId, setSelectedDepartmentId] = useState(null); // For deleting or editing
  const [editableDepartmentName, setEditableDepartmentName] = useState('');
  const [departmentIdToDelete, setDepartmentIdToDelete] = useState(null);

  const [hiddenDepartmentIds, setHiddenDepartmentIds] = useState(() => {
    // Load hidden IDs from localStorage on first render
    const stored = localStorage.getItem("hiddenDepartmentIds");
    return stored ? JSON.parse(stored) : [];
  });

  useEffect(() => {
    const scriptUrls = [
      'assets/js/jquery.min.js',
      'assets/js/bootstrap.bundle.min.js',
      'assets/js/moment.min.js',
      'assets/vendor/overlay-scroll/jquery.overlayScrollbars.min.js',
      'assets/vendor/overlay-scroll/custom-scrollbar.js',
      'assets/vendor/daterange/daterange.js',
      'assets/vendor/daterange/custom-daterange.js',
      'assets/vendor/jquery-ui/jquery-ui.min.js',
      'assets/vendor/jquery-ui/custom.js',
      'assets/vendor/datatables/dataTables.min.js',
      'assets/vendor/datatables/dataTables.bootstrap.min.js',
      'assets/vendor/datatables/custom/custom-datatables.js',
      'assets/js/custom.js'
    ];

    let isCancelled = false;

    // Load scripts sequentially
    const loadScriptsSequentially = async () => {
      for (const url of scriptUrls) {
        if (isCancelled) break;

        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = url;
          script.onload = resolve;
          script.onerror = reject;
          document.body.appendChild(script);
        });
      }
    };

    loadScriptsSequentially();

    return () => {
      isCancelled = true;
      // Optionally remove scripts if needed
    };
  }, []);

  const [departmentName, setDepartmentName] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();

    const departmentData = {
      departmentName: departmentName,

    };

    // Send POST request to the backend API
    axios
      .post('http://localhost:8080/webnet-hms/api/department', departmentData)
      .then((response) => {
        console.log('Department added successfully:', response.data);
        alert('✅ Department added successfully!');
        setDepartmentName('');
        fetchDeprtment();

      })
      .catch((error) => {
        console.error('Error adding department:', error);
        alert('❌ Failed to add department. Please try again.');
      });
  };



  const navigator = useNavigate();



  const navigators = useNavigate();
  const handleUpdateClick = (e, id) => {
    e.preventDefault();
    // Navigate to /page2 and pass the value
    navigators('/edit-departments', { state: { uata: id } });
    window.location.reload();
  };

  const handleSoftDelete = (departmentId) => {
    axios.delete(`http://localhost:8080/webnet-hms/api/department/${departmentId}`)
      .then((response) => {
        alert('Department marked as deleted');
        setDepartments((prevDepartments) =>
          prevDepartments.filter((dept) => dept.departmentId !== departmentId)
        ); // Remove the department from the state to hide it
      })
      .catch((error) => {
        console.error('Error marking department as deleted:', error);
      });
  };


  useEffect(() => {
    axios.get("http://localhost:8080/webnet-hms/api/department")
      .then((response) => {
        // Filter out hidden departments
        const filtered = response.data.filter(
          dept => !hiddenDepartmentIds.includes(dept.departmentId)
        );
        setDepartments(filtered);
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
      });
  }, [hiddenDepartmentIds]);

  // const handleDeleteClick = (e, id) => {
  //   e.preventDefault();

  //   const confirmDelete = window.confirm("Are you sure you want to hide this department?");
  //   if (!confirmDelete) return;

  //   const updatedHidden = [...hiddenDepartmentIds, id];
  //   localStorage.setItem("hiddenDepartmentIds", JSON.stringify(updatedHidden));
  //   setHiddenDepartmentIds(updatedHidden); // Trigger re-render
  // };

  const handleDeleteClick = (e, id) => {
    e.preventDefault();
    // Deletes the department
    const REST_API_BASE_URL = `http://localhost:8080/webnet-hms/api/delete-department/${id}`;

    axios.post(REST_API_BASE_URL)
      .then((response) => {
        console.log(response.data);
        window.alert(`This happend with: ${response.data}`);

        // After deletion, redirect to another page (e.g., home or item list)
        navigators("/departments-list"); // Navigates back to the homepage or another route
      })
      .catch((error) => {
        window.alert("Error occurred while deleting the item.");
        console.error(error);
      });
  };

  

  const [department, setDepartment] = useState([]);
  const srcImg = "http://localhost:8080/Images/";
  useEffect(() => {
    const REST_API_BASE_URL = `http://localhost:8080/api/listBooksByUsers`;
    const listDoctorUser = () => axios.get(REST_API_BASE_URL);
    listDoctorUser().then((response) => {
      setDepartment(response.data);
    }).catch(error => {
      console.error(error);
    })
  }, [])
  

  function handleCancelDepartment(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "none";
    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "none";

    let addButtons = document.getElementById('add')
    addButtons.style.display = "block";


  }
  function addDepatmentPanel(e) {
    e.preventDefault();
    let divPanel = document.getElementById('divPanel')
    divPanel.style.display = "block";

    let divButtons = document.getElementById('cancel')
    divButtons.style.display = "block";
    let addButtons = document.getElementById('add');
    addButtons.style.display = "none";


  }

  useEffect(() => {
    axios.get('http://localhost:8080/webnet-hms/api/department')
      .then((response) => {
        // Check if response.data is an array
        if (Array.isArray(response.data)) {
          setDepartments(response.data);
        } else {
          console.error('Data is not an array', response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching departments:", error);
      });
  }, []);

  const handleEditConfirm = () => {
    const departmentId = Number(selectedDepartmentId); // Ensure it's a number

    if (!editableDepartmentName.trim()) {
      alert("Department name cannot be empty.");
      return;
    }

    axios.put(`http://localhost:8080/webnet-hms/api/department/${departmentId}`, {
      departmentId: departmentId,
      departmentName: editableDepartmentName,
      designationIds: null,
      userIds: null
    })
      .then((response) => {
        // Update department in the list
        setDepartments(departments.map(dept =>
          dept.departmentId === departmentId
            ? { ...dept, departmentName: editableDepartmentName }
            : dept
        ));
        alert('Department updated successfully!');
        fetchDeprtment()
      })
      .catch((error) => {
        console.error('Error updating department:', error);
        alert('Failed to update department');
      });
  };

  const handleEditClick = (id, departmentName) => {
    // Set the selected department ID and name for editing
    setSelectedDepartmentId(id);
    setEditableDepartmentName(departmentName); // Set the department name to be editable
  };
  const fetchDeprtment = () => {
    axios
      .get("http://localhost:8080/webnet-hms/api/department")
      .then((response) => {
        setDepartments(response.data);
      })
      .catch((error) => {
        console.error("Error fetching user types:", error);
      });
  };


  return (

    <div>
      {/* App hero header starts */}
      <div className="app-hero-header d-flex align-items-center">
        {/* Breadcrumb starts */}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="index-2.html">
              <i className="ri-home-3-line" />
            </a>
          </li>
          <li className="breadcrumb-item">Department</li>
          <li className="breadcrumb-item text-primary" aria-current="page">
            Add Department
          </li>
        </ol>

        {/* Sales stats ends */}
      </div>
      {/* App Hero header ends */}
      {/* App body starts */}
      <div className="app-body">
        {/* Row starts */}
        <div className="row gx-4">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                {/* Custom tabs starts */}
                <div className="custom-tabs-container">
                  {/* Nav tabs starts */}

                  {/* Nav tabs ends */}
                  {/* Tab content starts */}
                  <div className="tab-content h-350" style={{ paddingTop: "0.5rem;" }}>

                    <div className="tab-pane fade show active" id="twoA" role="tabpanel">
                      {/* Row starts */}
                      <div className="row justify-content-left">
                        <div className="col-sm-12 col-12" id="divPanel" style={{ display: "none" }}>
                          <div className="card border mb-3">
                            <div className=" card-body ">

                              <form onSubmit={handleSubmit}>

                                <div className="row align-items-end g-3">

                                  <h4>Add Department</h4>
                                  <div className="col-md-4">
                                    <label className="form-label" htmlFor="a2">Department</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      id="a2"
                                      placeholder="Department"
                                      value={departmentName}
                                      onChange={(e) => setDepartmentName(e.target.value)}


                                    />
                                  </div>

                                  <div className="col-md-8 d-flex align-items-end justify-content-end">
                                    <button type="submit" className="btn btn-primary">
                                      Add Deparment
                                    </button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>

                        </div>
                        {/*  */}

                        {/* d-flex gap-2 */}

                      </div>
                      {/* Row ends */}
                      <div className="card border">

                        <div className="card-body pt-15">
                          {/* Table starts */}
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="card-title mb-0">Department List</h5>

                            <div>
                              <button type="button" id="cancel" className="btn btn-primary me-2" style={{ display: "none" }} onClick={handleCancelDepartment}>
                                Cancel
                              </button>
                              <button type="button" id="add" className="btn btn-primary" onClick={addDepatmentPanel}>
                                Add Deparment
                              </button>
                            </div>
                          </div>

                          <div className="table-responsive">
                          <table id="basicExample" className="table m-0 align-middle">
                              <thead>
                                <tr>
                                  <th>ID</th>
                                  <th>Department Name</th>
                                  <th>Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {departments.map((dept) => (
                                  <tr key={dept.departmentId}>
                                    <td>{dept.departmentId}</td>
                                    <td>{dept.departmentName}</td>
                                    <td>
                                      {/* <button onClick={() => handleEditClick(dept.departmentId, dept.departmentName)}>Edit</button> */}
                                      <button
                                          className="btn btn-outline-success btn-sm"
                                          data-bs-toggle="modal"
                                          data-bs-target="#editModules"
                                          

                                          onClick={() => handleEditClick(dept.departmentId, dept.departmentName)}

                                        >
                                          <i className="ri-edit-box-line" />
                                        </button>
                                      
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Table ends */}
                          {/* Modal Delete Row */}
                          <div className="modal fade" id="delRow" tabIndex={-1} aria-labelledby="delRowLabel" aria-hidden="true">
                            <div className="modal-dialog modal-sm">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="delRowLabel">
                                    Confirm
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  Are you sure you want to delete the doctor from list?
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>

                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={() => handleSoftDelete(departmentIdToDelete)}>Yes</button>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {/* Modal Delete Row */}
                          <div className="modal fade" id="editModules" tabIndex={-1} aria-labelledby="editModulesLabel" aria-hidden="true">
                            <div className="modal-dialog modal-md">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title" id="iconRowLabel">
                                    Edit
                                  </h5>
                                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                                </div>
                                <div className="modal-body">
                                  <div className="row justify-content-left">
                                    <div className="col-sm-12 col-12" id="divPanel">

                                      <div className="card border mb-3">
                                        <div className="card-body">

                                          <div className="row gx-4">

                                            <div className="col-sm-6 col-12">
                                              <div className="mb-3">
                                                <label className="form-label" htmlFor="a2">Department</label>
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  id="a2"
                                                  placeholder="Department"
                                                  value={editableDepartmentName}
                                                  onChange={(e) => setEditableDepartmentName(e.target.value)}
                                                />

                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <div className="d-flex justify-content-end gap-2">
                                    <button className="btn btn-outline-secondary" data-bs-dismiss="modal" aria-label="Close">No</button>
                                    <button className="btn btn-danger" data-bs-dismiss="modal" aria-label="Close" onClick={handleEditConfirm}>Edit</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Tab content ends */}
                </div>
                {/* Custom tabs ends */}
                {/* Buttons starts */}

                {/* Buttons ends */}
              </div>
            </div>
          </div>
        </div>
        {/* Row ends */}
      </div>
      {/* App body ends */}
    </div>
  );
}
export default Departments;
